module.exports = __webpack_public_path__ + "static/media/CR.91784dc5.svg";